import React, { useEffect, useState } from 'react';
import { ThemedText, ThemedView } from '@app/theme';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import gs from '../../../styles/globalStyles';
import Button from '@app/sharedComponents/Button/Button';
import InputText from '@app/sharedComponents/TextInput/TextInput';
import { useDarkMode } from '@app/utils';
import { CheckCircle } from '@sharedComponents/Icons';
import useIsMobileBrowser from '@app/hooks/useIsMobileBrowser';
import { Platform } from 'react-native';

type EditMobileNumberModalProps = {
    isVisible: boolean;
    onClose: () => void;
    mobileNumberTemp: string;
    onUpdate: (mobileNumber: string) => void;
    buttonLoader: boolean;
    routeName: string;
};

const EditMobileNumberModal: React.FC<EditMobileNumberModalProps> = ({
    isVisible,
    onClose,
    mobileNumberTemp,
    onUpdate,
    buttonLoader,
    routeName
}) => {
    const isDarkMode = useDarkMode();
    const [mobileNumber, setMobileNumber] = useState<string>(mobileNumberTemp);
    const [isMobileNumberValid, setIsMobileNumberValid] = useState<boolean>(true);
    const isMobileBrowser = useIsMobileBrowser()

    const onInputTemp = (text: string) => {
        let formattedText = text.replace(/[^0-9]/g, '');
        if (formattedText.length > 10) {
            formattedText = formattedText.slice(0, 10);
        }
        setMobileNumber(formattedText);
        if (formattedText.length === 10) {
            setIsMobileNumberValid(true);
        } else {
            setIsMobileNumberValid(false);
        }
    };

    useEffect(() => {
        setMobileNumber(mobileNumberTemp);
    }, [mobileNumberTemp])

    return (
        //@ts-expect-error
        <BottomSheetContainer
            isVisible={isVisible}
            close={onClose}
            showCloseIcon={true}
            closeOnBackdropPress={false}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            //@ts-expect-error
            containerStyle={[gs.setBg('#fefefe'), {
                maxHeight: '80%',
                minHeight: isMobileBrowser ? 290 : undefined, 
            }]}
        >
            <ThemedView padding='lg' pt='2xl' pb='5xl'>
                <ThemedText variant='h3s' fontWeight='600'>Edit mobile number</ThemedText>
                <ThemedText variant='b3r' color='text-secondary' mt={"sm"} mb={"2xl"}>Use mobile number linked to your investments.</ThemedText>
                <ThemedView>
                    <InputText
                        keyboardType="phone-pad"
                        onChangeText={onInputTemp}
                        value={mobileNumber}
                        showAnimation
                        showLabel
                        autoFocus={true}
                        label={'Mobile number'}
                        showLeftAccessory
                        isDarkMode={Boolean(isDarkMode)}
                        leftAccessory={() => {
                            return (
                                <ThemedView style={{ marginRight: 5 }} flexDirection="row" alignItems="center">
                                    <ThemedText variant='b2r' color='text-secondary' fontWeight='400'>+91</ThemedText>
                                </ThemedView>
                            );
                        }}
                        showRightAccessory={mobileNumberTemp.length >= 1}
                        rightAccessory={() => {
                            return (
                                <ThemedView flexDirection="row" alignItems="center">
                                    {isMobileNumberValid ? (
                                        //@ts-ignore
                                        <CheckCircle
                                            size={20}
                                            weight="fill"
                                            fill="rgb(18, 183, 106)"
                                        />
                                    ) : (
                                        <ThemedText variant='b4r' color='text-secondary' fontWeight='400'>{`${mobileNumber?.length}/10`}</ThemedText>
                                    )}
                                </ThemedView>
                            );
                        }}
                        showErrorMessage={true}
                        maxLength={10}
                    />
                </ThemedView>
                <Button
                    eventName={'UPDATE_MOBILE_NUMBER'}
                    additionalProperties={{
                        source : 'MF_FETCH_PORTFOLIO'
                    }}
                    label={'Update mobile number'}
                    handlePress={() => onUpdate && onUpdate(mobileNumber)}
                    type={'SOLID'}
                    size='MD'
                    bg='bg-primary'
                    textColor='text-primary'
                    disabled={!isMobileNumberValid}
                    buttonLoader={buttonLoader}
                />
                {Platform.OS === 'android' && (
                    <ThemedView height={20} />
                )}
            </ThemedView>
        </BottomSheetContainer>
    );
};

export default EditMobileNumberModal; 